import { Tag } from '../../models/tag.interface';

export class TagState {
  tags: Tag[] = [];
}
